export default __webpack_public_path__ + "static/media/login-page-img.e1fc2f4f.png";